import React from 'react';
import { SSPDashboard } from '../../components/dashboards/ssp/SSPDashboard';

export const SSPDashboardPage: React.FC = () => {
  return <SSPDashboard />;
};